module.exports = __webpack_public_path__ + "img/GK9903-GK.c5376ac5.jpg";